
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.84 3.51h-2.763V2.157c0-.869-.551-1.55-1.255-1.55H5.18c-.704 0-1.256.681-1.256 1.55V3.51H1.16c-.6 0-1.08.52-1.08 1.15v5.25c0 .63.48 1.14 1.08 1.14h2.76v1.9c0 .8.63 1.439 1.41 1.439h4.34c.78 0 1.41-.64 1.41-1.439v-1.9h2.76c.601 0 1.08-.51 1.08-1.14V4.66c0-.63-.48-1.15-1.08-1.15zM4.924 2.157c0-.357.182-.55.256-.55h4.643c.074 0 .255.193.255.55V3.51H4.924V2.157zm5.156 7.893v2.9c0 .25-.18.439-.41.439H5.33c-.23 0-.41-.189-.41-.439V8.137h5.16v1.913zm3.84-.14c0 .09-.05.14-.08.14h-2.76V8.137h1.067a.5.5 0 000-1H2.854a.5.5 0 000 1H3.92v1.913H1.16c-.03 0-.08-.05-.08-.14V4.66c0-.09.05-.15.08-.15h12.68c.03 0 .08.05.08.15v5.25z"}})])
          )
        }
      }
    